import React, { useEffect } from "react";
import styled from "styled-components";
import { useState } from "react";
import { useParams } from "react-router-dom";
import useGetReportList from "../hooks/useGetReportList";

// img
import toggleBefore from "../img/toggle.svg";
import toggleAfter from "../img/toggleAfter.svg";

// styled components

// components
import ChartList from "./ChartList";
import { device } from "../hooks/device";
import { useRecoilValue } from "recoil";
import { languageIs } from "../atoms";

const ReportDown = () => {
  const [clickAbnormal, setClickAbnormal] = useState(false);
  const [clickNotComplete, setClickNotComplete] = useState(false);
  const [clickNormal, setClickNormal] = useState(false);
  const [lang, setLang] = useState("kr");
  const testId = useParams("testId").testId;

  const { data } = useGetReportList({ lang, testId });
  const country = useRecoilValue(languageIs);
  const detectList = data?.testerList?.detectList;
  const normalList = data?.testerList?.normalList;
  const notTakingList = data?.testerList?.notTakingList;
  const analysisErrorList = data?.testerList?.analysisErrorList;
  const [midList, setMidList] = useState();

  useEffect(() => {
    if (country === "/ko") {
      setLang("kr");
    } else {
      setLang("en");
    }
  }, [country]);

  useEffect(() => {
    if (notTakingList) {
      setMidList([...analysisErrorList, ...notTakingList]);
    }
  }, [notTakingList, analysisErrorList]);

  return (
    <StBack>
      <div className="body">
        <div className="boxForEachState">
          <div className="titleBox">
            <div className="middle">
              확인 요망 / 주의 요망 ({detectList?.length})
            </div>
            {clickAbnormal ? (
              <img
                className="stImg"
                alt=""
                onClick={() => {
                  setClickAbnormal(false);
                }}
                src={toggleAfter}
              />
            ) : (
              <img
                className="stImg"
                alt=""
                onClick={() => {
                  setClickAbnormal(true);
                }}
                src={toggleBefore}
              />
            )}
          </div>
          {clickAbnormal ? (
            <></>
          ) : (
            <>
              {detectList?.length > 0 ? (
                <div className="griding">
                  {detectList && (
                    <>
                      {detectList?.map((value, index) => (
                        <ChartList
                          key={index + 1}
                          check={value?.check}
                          testerId={value?.testerId}
                          testId={testId}
                          name={value?.testerName}
                          abnormals={value?.abnormals}
                          cheats={value?.cheats}
                          id={value?.video_id}
                        />
                      ))}
                    </>
                  )}
                </div>
              ) : (
                <div className="nothing">관련 응시자가 없음</div>
              )}
            </>
          )}
        </div>
        <div className="boxForEachState">
          <div className="titleBox">
            <div className="middle">
              {(analysisErrorList?.length > 0) & (notTakingList?.length > 0)
                ? `분석 오류 발생 / 미완료된 응시 (${
                    notTakingList?.length + analysisErrorList?.length
                  })`
                : ""}
              {(analysisErrorList?.length > 0) & (notTakingList?.length === 0)
                ? `분석 오류 발생 (${analysisErrorList.length})`
                : ""}
              {(analysisErrorList?.length === 0) & (notTakingList?.length >= 0)
                ? `미완료된 응시 (${notTakingList?.length})`
                : ""}
            </div>
            {clickNotComplete ? (
              <img
                className="stImg"
                alt=""
                onClick={() => {
                  setClickNotComplete(false);
                }}
                src={toggleAfter}
              />
            ) : (
              <img
                className="stImg"
                alt=""
                onClick={() => {
                  setClickNotComplete(true);
                }}
                src={toggleBefore}
              />
            )}
          </div>
          {clickNotComplete ? (
            <></>
          ) : (
            <>
              {midList?.length > 0 ? (
                <div className="griding">
                  {midList && (
                    <>
                      {midList?.map((value, index) => (
                        <ChartList
                          key={index + 1}
                          check={value?.check}
                          testerId={value?.testerId}
                          testId={testId}
                          name={value?.testerName}
                          abnormals={value?.abnormals}
                          cheats={value?.cheats}
                        />
                      ))}
                    </>
                  )}
                </div>
              ) : (
                <div className="nothing">관련 응시자가 없음</div>
              )}
            </>
          )}
        </div>
        <div className="boxForEachState">
          <div className="titleBox">
            <div className="middle">정상 응시 ({normalList?.length})</div>
            {clickNormal ? (
              <img
                className="stImg"
                alt=""
                onClick={() => {
                  setClickNormal(false);
                }}
                src={toggleAfter}
              />
            ) : (
              <img
                className="stImg"
                alt=""
                onClick={() => {
                  setClickNormal(true);
                }}
                src={toggleBefore}
              />
            )}
          </div>
          {clickNormal ? (
            <></>
          ) : (
            <>
              {normalList?.length > 0 ? (
                <div className="griding">
                  {normalList && (
                    <>
                      {normalList?.map((value, index) => (
                        <ChartList
                          key={index + 1}
                          check={value?.check}
                          testerId={value?.testerId}
                          testId={testId}
                          name={value?.testerName}
                          abnormals={value?.abnormals}
                          cheats={value?.cheats}
                        />
                      ))}
                    </>
                  )}
                </div>
              ) : (
                <div className="nothing">관련 응시자가 없음</div>
              )}
            </>
          )}
        </div>
      </div>
    </StBack>
  );
};

const StBack = styled.div`
  @media ${device.tabMob} {
    width: 100%;
    background-color: #f0f1f2;
    margin: 0 auto;
    padding: 24px 24px 44px;
    box-sizing: border-box;
    .nothing {
      display: flex;
      width: 100%;
      height: 90px;
      justify-content: center;
      align-items: center;
      color: #bdbdbd;
      font-size: 14px;
    }
    .body {
      display: grid;
      flex-direction: column;
      width: 100%;
      margin: 0 auto 0 auto;
      gap: 44px;
      .boxForEachState {
        display: grid;
        flex-direction: column;
        gap: 12px;
        .titleBox {
          display: flex;
          align-items: center;
          margin-bottom: 4px;
          .middle {
            font-size: 18px;
            font-family: "Bold";
            line-height: 21px;
          }
        }
      }
    }
    .griding {
      display: grid;
      grid-template-columns: 100%;
      gap: 12px;
    }
    .stImg {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0 0 20px;
      cursor: pointer;
    }
  }
  @media ${device.pc} {
    width: 100vw;
    max-width: 100%;
    min-width: 1440px;
    background-color: #f0f1f2;
    padding: 60px 0 80px;
    .body {
      display: grid;
      flex-direction: column;
      gap: 60px;
      width: 1228px;
      margin: 0 auto;
      .boxForEachState {
        display: grid;
        flex-direction: column;
        gap: 24px;
      }
    }
    .nothing {
      display: flex;
      width: 100%;
      height: 90px;
      justify-content: center;
      align-items: center;
      color: #bdbdbd;
    }
    .griding {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 20px;
    }
    .stImg {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0 0 15px;
      cursor: pointer;
    }
    .titleBox {
      display: flex;
      align-items: center;
      .middle {
        font-size: 22px;
        font-family: "Bold";
        line-height: 33px;
      }
    }
  }
`;

export default ReportDown;
